// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// https://itnext.io/vuejs-and-webpack-4-from-scratch-part-1-94c9c28a534a
// https://medium.com/codingthesmartway-com-blog/vue-js-2-quickstart-tutorial-2017-246195cfbdd2
var $urlRoot = "";

import 'bootstrap/dist/css/bootstrap.min.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    import Vue from 'vue'
     
    import BootstrapVue from 'bootstrap-vue'
    import App from './App'
    import router from './router'
    import './assets/app.css'
    import R from './static/R.js'
    import Localization from './dao/Localization.js'

// import 'mdbvue/build/css/mdb.css';
// import { Container, Row, Column, Btn, Card, CardBody, CardHeader, CardImg } from 'mdbvue';
    Vue.use(BootstrapVue)
// config object 

Vue.config.productionTip = false

document.title = Localization.translate(R.stringId.appname)
/* eslint-disable no-new */
//router.beforeEach((to, from, next) => {
//  /* must call `next` */
//  if(location.pathname.match('/static/articles/.*')==null){
//        
//       next();
//  }
//  else{ 
//  } 
// 
//})
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js